import React from "react";
import styled from 'styled-components';
import theme from '../../../styles/theme';

const MainWrap =  styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: ${theme.color.black[60]};
    z-index: 1300;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const MainBody = styled.div`
    width: calc(90% - 32px);
    // height: 6rem;
    max-width: calc(90% - 32px);
    max-height: 12rem;
    background: ${theme.color.white[100]};
    border-radius: 16px;
    padding: 16px;
`;

const MobileMsgModal = (props) => {

    return props.open===true && props.children ? (
        <MainWrap>
            <MainBody>
                {props.children}
            </MainBody>
        </MainWrap>
    )
    : <React.Fragment />

}

export default MobileMsgModal;